import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { popupActions } from "../_actions";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import Loading from "../components/Loading";

class PopupWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = { popupShouldDisplay: false };
    this.closeModal = this.closeModal.bind(this);
  }
  componentWillMount() {
    this.props.dispatch(popupActions.getDetail());
  }
  closeModal() {
    this.setState({ popupShouldDisplay: false });

    let oldUser = JSON.parse(localStorage.getItem("user"));
    const user = {
      ...oldUser,
      popupShouldDisplay: false
    };
    localStorage.setItem("user", JSON.stringify(user));

    this.props.dispatch(popupActions.saveClose(this.props.detail[0].popup_id));
  }
  render() {
    return (
      <div>
        {!this.props.fetchingDetail && this.props.detail[0] && (
          <Popup
            onClose={this.closeModal}
            // open={this.state.popupShouldDisplay}
            defaultOpen={true}
            modal={true}
            position="right center"
          >
            <div>
              <div>
                <h1 className="popup-title">{this.props.detail[0].title}</h1>
                <p className="popup-desc">{this.props.detail[0].message}</p>
                {this.props.fetchingDetail && <Loading />}
                <button className="popup-close" onClick={this.closeModal}>
                  Okay
                </button>
              </div>
            </div>
          </Popup>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.popup
  };
}

export default connect(mapStateToProps)(PopupWrapper);
